/* tslint:disable */
/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const getEspRegisterNo = /* GraphQL */ `
  query GetEspRegisterNo($input: register_key_no) {
    getEspRegisterNo(input: $input) {
      esp_estima_no
    }
  }
`;
export const getFilEstimaDetail = /* GraphQL */ `
  query GetFilEstimaDetail($input: fil_estima_detail_pk) {
    getFilEstimaDetail(input: $input) {
      esd_est_kb_no
      esd_estima_no
      esd_hin_cd
      esd_hin_kb
      esd_hin_nm
      esd_maintenance_price
      esd_net_price
      esd_net_rate
      esd_net_reason
      esd_product_price
      esd_standard_price
      esd_suryo
    }
  }
`;
export const getFilEstimaPoint = /* GraphQL */ `
  query GetFilEstimaPoint($input: fil_estima_point_pk) {
    getFilEstimaPoint(input: $input) {
      esp_contract_period
      esp_customer_nm
      esp_divide_maintenance
      esp_es_deli_date_st
      esp_est_date
      esp_est_kb_no
      esp_est_nm
      esp_estima_no
      esp_ex_date_st
      esp_license_net_rate
      esp_license_num
      esp_mainte_cont
      esp_maintenance_net_rate
      esp_memo1
      esp_memo2
      esp_memo3
      esp_municipalities
      esp_net_reason
      esp_new_or_add_kb
      esp_office_cd
      esp_prefectures
      esp_primary_cd
      esp_primary_nm
      esp_primary_rep
      esp_print_format
      esp_product_cd
      esp_remaining_month
      esp_secondary_cd
      esp_secondary_nm
      esp_secondary_rep
      esp_set_model
      esp_sh_jyoken
      esp_soft_mainte_price
      esp_software_net_rate
      esp_syain_cd
      esp_template_net_rate
      esp_useware_net_rate
      esp_software_discount_rate
      esp_template_discount_rate
      esp_license_discount_rate
      esp_useware_discount_rate
      esp_maintenance_discount_rate
      esp_sum_mainte_price
    }
  }
`;
export const getFilEstimaPointList = /* GraphQL */ `
  query GetFilEstimaPointList($input: fil_estima_point_filter) {
    getFilEstimaPointList(input: $input) {
      esp_contract_period
      esp_customer_nm
      esp_divide_maintenance
      esp_es_deli_date_st
      esp_est_date
      esp_est_kb_no
      esp_est_nm
      esp_estima_no
      esp_ex_date_st
      esp_license_net_rate
      esp_license_num
      esp_mainte_cont
      esp_maintenance_net_rate
      esp_memo1
      esp_memo2
      esp_memo3
      esp_municipalities
      esp_net_reason
      esp_new_or_add_kb
      esp_office_cd
      esp_prefectures
      esp_primary_cd
      esp_primary_nm
      esp_primary_rep
      esp_print_format
      esp_product_cd
      esp_remaining_month
      esp_secondary_cd
      esp_secondary_nm
      esp_secondary_rep
      esp_set_model
      esp_sh_jyoken
      esp_soft_mainte_price
      esp_software_net_rate
      esp_syain_cd
      esp_template_net_rate
      esp_useware_net_rate
      esp_software_discount_rate
      esp_template_discount_rate
      esp_license_discount_rate
      esp_useware_discount_rate
      esp_maintenance_discount_rate
    }
  }
`;
export const getLogMaintenance = /* GraphQL */ `
  query GetLogMaintenance($input: log_maintenance_pk) {
    getLogMaintenance(input: $input) {
      lm_start_time
      lm_start_user_nm
      lm_status_kb
    }
  }
`;
export const getMstContractPeriod = /* GraphQL */ `
  query GetMstContractPeriod($input: mst_contract_period_pk) {
    getMstContractPeriod(input: $input) {
      mcp_maintenance_discount_rate
      mcp_usage_fee_discount_rate
      mcp_years
    }
  }
`;
export const getMstControlRule = /* GraphQL */ `
  query GetMstControlRule($input: mst_control_rule_pk) {
    getMstControlRule(input: $input) {
      mcr_condition1
      mcr_condition2
      mcr_condition3
      mcr_control_item
      mcr_control_kb
      mcr_process_order
    }
  }
`;
export const getMstHinInfo = /* GraphQL */ `
  query GetMstHinInfo($input: mst_hin_info_pk) {
    getMstHinInfo(input: $input) {
      mhi_add_hinmei1
      mhi_add_hinmei2
      mhi_available_kb
      mhi_hin_cd
      mhi_maintenance_price
      mhi_oso_cd
      mhi_primary_cd
      mhi_product_cd
      mhi_product_price
      mhi_secondary_cd
      mhi_years
      mhi_default_suryo
    }
  }
`;
export const getMstHinmei = /* GraphQL */ `
  query GetMstHinmei($input: mst_hinmei_filter) {
    getMstHinmei(input: $input) {
      mh_available_kb
      mh_discount_kb
      mh_freename_kb
      mh_hin_cd
      mh_hin_kb
      mh_hin_nm
      mh_maintenance_kb
      mh_maintenance_tani
    }
  }
`;
export const getMstNetRate = /* GraphQL */ `
  query GetMstNetRate($input: mst_net_rate_pk) {
    getMstNetRate(input: $input) {
      mnr_license_net_rate
      mnr_maintenance_net_rate
      mnr_primary_cd
      mnr_product_cd
      mnr_secondary_cd
      mnr_software_net_rate
      mnr_template_net_rate
      mnr_useware_net_rate
    }
  }
`;
export const getMstOffice = /* GraphQL */ `
  query GetMstOffice($input: mst_office_filter) {
    getMstOffice(input: $input) {
      mo_address
      mo_fax
      mo_office_cd
      mo_office_nm
      mo_post
      mo_tel
    }
  }
`;
export const getMstPrimarySales = /* GraphQL */ `
  query GetMstPrimarySales($input: mst_primary_sales_filter) {
    getMstPrimarySales(input: $input) {
      mps_primary_cd
      mps_primary_nm
    }
  }
`;
export const getMstProduct = /* GraphQL */ `
  query GetMstProduct($input: mst_product_filter) {
    getMstProduct(input: $input) {
      mpr_available_kb
      mpr_discount_type
      mpr_maintenance_limit
      mpr_product_cd
      mpr_product_nm
    }
  }
`;
export const getMstRemarks = /* GraphQL */ `
  query GetMstRemarks($input: mst_remarks_filter) {
    getMstRemarks(input: $input) {
      mrm_remarks
      mrm_remarks_cd
      mrm_remarks_kb
    }
  }
`;
export const getMstSecondarySales = /* GraphQL */ `
  query GetMstSecondarySales($input: mst_secondary_sales_filter) {
    getMstSecondarySales(input: $input) {
      mss_primary_cd
      mss_secondary_cd
      mss_secondary_nm
    }
  }
`;
export const getMstUser = /* GraphQL */ `
  query GetMstUser($input: mst_user_filter) {
    getMstUser(input: $input) {
      mu_admin_kb
      mu_mail
      mu_office_cd
      mu_user_id
      mu_user_nm
    }
  }
`;
export const getUserInfo = /* GraphQL */ `
  query GetUserInfo($input: mst_user_pk) {
    getUserInfo(input: $input) {
      mo_office_nm
      mu_admin_kb
      mu_mail
      mu_office_cd
      mu_user_id
      mu_user_nm
    }
  }
`;
